<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :customTopActions="true"
      :bodyFilter="true"
      item-key="id"
      table-height="70vh"
    >
      <template v-slot:top>
        <div class="d-flex justify-end my-4 mr-6">
          <v-btn
            color="primary"
            class="mb-2 rounded-pill elevation-0"
            @click="addItem"
            :disabled="loading"
          >
            Create Promo
          </v-btn>

          <v-btn
            icon
            color="warning"
            class="mb-2 ml-2"
            @click="getData"
            :loading="loading"
            :disabled="loading"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:body-prepend>
        <promo-filter :search="search" v-on:getDataParent="searchFilter" />
      </template>
      <template v-slot:action="{ item }">
        <td class="d-block d-sm-table-cell d-print-table-cell">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item.id)"
            :disabled="item.disabled_edit == 'true'"
          >
            mdi-pencil
          </v-icon>
          <v-icon small class="mr-2" @click="viewItem(item.id)"> mdi-eye </v-icon>
        </td>
      </template>
    </TableView>

    <v-dialog v-model="view" max-width="500px">
      <promo-detail :editedItem="editedItem" v-on:closeParent="close" />
    </v-dialog>
  </v-card>
</template>

<script>
import { date } from '../../lib/helpers';
import { headers, editedItem, search } from '../../components/promo/attributes';

export default {
  components: {
    PromoFilter: () => import('../../components/table/PromoFilter.vue'),
    PromoDetail: () => import('../../components/table/PromoDetail.vue'),
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
  },

  data: () => ({
    listButton: {
      buttonRestart: true,
      buttonAdd: {
        label: 'Create Promo',
      },
    },
    isFirstLoad: false,
    options: {},
    view: false,
    dialog: false,
    headers,
    search,
    editedItem,
    selectedRow: '',
    editedIndex: -1,
  }),

  computed: {
    allData() {
      return this.$store.state.promo.allData;
    },
    detailData() {
      return this.$store.state.promo.item;
    },
    totalData() {
      return this.$store.state.promo.totalData;
    },
    totalPage() {
      return this.$store.state.promo.totalPage;
    },
    loading() {
      return this.$store.state.promo.loading;
    },

    flashError: {
      get() {
        return this.$store.state.promo.flashError;
      },
      set() {
        this.$store.commit('promo/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.promo.flashErrorMessage;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('promo/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },
    searchFilter(){
      this.options.page = 1;
      this.getData();
    },
    getData() {
      this.$store.commit('promo/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('promo/getData', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    addItem() {
      this.$router.push({ path: '/promo/add' });
    },

    async viewItem(itemId) {
      await this.$store
        .dispatch('promo/getDetail', {
          id: itemId,
          date,
        })
        .then(() => {
          if (!this.loading && this.detailData != null) {
            this.editedIndex = itemId;
          }
          this.editedItem = { ...this.detailData };
          this.view = true;
          this.editedIndex = -2;
        });
    },

    async editItem(itemId) {
      this.$router.push({ path: `/promo/edit/${itemId}` });
    },

    close() {
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit('promo/setFlashErrorMessage', '');
    },

    clearSearch() {
      this.search.jenis_promo = '';
      this.search.start_datetime = [];
      this.search.end_datetime = [];
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
